import { findDeepGetActivityOfTask } from '../../../../views/lookahead/planification/index.helper';
import dropdownHTML from '../../components/dropdownHTML';
import {
  prepareUIElements,
  setupGlobalHandlers,
  registerTaskCallbacks,
  updateTask,
  getParentTask
} from './utils';
import {
  getIsOdd,
  getIsOnlyReadElement,
  getTaskFromLookahead
} from '../common/validators';

const renderLean = (props) => {
  const { gantt, activities, column, onlyRead, task, mainObject, t } = props;
  setupGlobalHandlers();

  if (!task.isTask && gantt) return '';
  if (task.is_milestone) return null;

  const selectedObject = mainObject || task;
  const optionsList = column.from_values;
  const taskFromLookahead = getTaskFromLookahead(activities, gantt, task.id);
  const { subtradeRole } = gantt;
  const isOnlyReadElement = getIsOnlyReadElement(onlyRead, task, subtradeRole);
  const isOdd = getIsOdd({ gantt, task });

  const activityReference = findDeepGetActivityOfTask(
    window.activities,
    'id',
    task.id
  );
  if (!activityReference) {
    return null;
  }

  updateTask(task, taskFromLookahead);

  const parentTask = getParentTask(taskFromLookahead, activities);
  registerTaskCallbacks(task.id, task, {
    taskFromLookahead,
    column,
    gantt,
    parentTask,
    activityReference,
    t
  });

  const { placeholderHtml, optionsListHtml, isReadOnly } = prepareUIElements({
    selectedObject,
    optionsList,
    isOnlyReadElement,
    column,
    task
  });

  const dropdownContent = `
      <ul class="options-list" onscroll="event.stopPropagation()">
        ${optionsListHtml}
      </ul>
    `;

  const dropdown = dropdownHTML({
    trigger: placeholderHtml,
    content: dropdownContent,
    width: column?.width,
    isReadOnly: isReadOnly,
    id: `lean-status-dropdown-${task.id}`,
    customClass: `custom-lean-status-dropdown`
  });

  return `
      <div 
        class="${isOdd ? 'odd-col' : 'non-odd-col'}"
        data-task-id="${task.id}"
        data-column-name="${column.name}">
        ${dropdown}
      </div>
    `;
};

export default renderLean;
